var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2191_1100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9489 120C48.0432 120.04 36.3932 116.556 26.4744 109.987C16.5555 103.419 8.81379 94.0622 4.22968 83.1023C-0.354441 72.1423 -1.5748 60.072 0.723135 48.4197C3.02107 36.7675 8.73394 26.0575 17.1383 17.646C25.5427 9.23451 36.2605 3.49983 47.9345 1.16818C59.6086 -1.16346 71.7138 0.0128025 82.7172 4.54802C93.7206 9.08324 103.127 16.7734 109.746 26.6447C116.365 36.516 119.898 48.1245 119.898 60C119.909 75.8811 113.603 91.1178 102.364 102.366C91.1245 113.615 75.8704 119.957 59.9489 120ZM59.9489 2.03389C48.4465 1.99363 37.1908 5.35903 27.6072 11.7039C18.0237 18.0488 10.5433 27.0877 6.11355 37.676C1.68377 48.2643 0.503786 59.9257 2.72304 71.1834C4.9423 82.4411 10.461 92.7887 18.5801 100.916C26.6993 109.043 37.0538 114.584 48.3323 116.837C59.6109 119.09 71.306 117.954 81.9368 113.573C92.5676 109.192 101.656 101.762 108.051 92.2253C114.445 82.6884 117.859 71.4732 117.859 60C117.864 44.66 111.771 29.9437 100.916 19.0776C90.0602 8.2115 75.328 2.08234 59.9489 2.03389Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.465 102.203H77.4861V101.186H101.445V77.2881H102.465V102.203Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.465 42.7118H101.445V18.8135H77.4861V17.7965H102.465V42.7118Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0654 42.7119H18.0459V17.7966H43.0247V18.8135H19.0654V42.7119Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0247 102.203H18.0459V77.2881H19.0654V101.186H43.0247V102.203Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.32 77.6542L101.586 76.922L118.572 59.9999L101.586 43.0779L102.32 42.3457L119.999 59.9999L102.32 77.6542Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.153 119.695L42.6577 102.061L43.3918 101.329L60.153 118.271L77.1182 101.329L77.8523 102.061L60.153 119.695Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1879 77.6542L0.509033 59.9999L18.2898 42.2643L37.1106 37.0169L42.6569 17.9389L60.1522 0.305023L77.8514 17.9389L77.1174 18.6711L60.1522 1.72875L43.4725 18.5694L37.9262 37.8304L18.82 43.1593L1.93639 59.9999L18.9219 76.922L18.1879 77.6542Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9828 77.5527L18.106 77.0239L28.1586 60.0001L18.106 42.9764L18.9828 42.4476L29.3413 60.0001L18.9828 77.5527Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2201 102.122L59.9491 91.322L43.3102 102.122L42.7393 101.268L59.9491 90.1017L77.7503 101.268L77.2201 102.122Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.505 77.5525L90.9634 60L101.505 42.4474L102.403 42.9763L92.146 60L102.403 77.0237L101.505 77.5525Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9746 101.817L76.9958 101.573L81.7469 81.539L82.0528 81.478L101.832 76.8L102.077 77.7763L82.6033 82.3932L77.9746 101.817Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.949 28.861L42.7595 18.7322L43.2897 17.878L59.949 27.6814L77.2404 17.8576L77.7298 18.7526L59.949 28.861Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.832 43.2L82.1751 38.0339L76.9958 18.4271L77.9746 18.183L82.9908 37.2203L102.077 42.2237L101.832 43.2Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5343 101.817L37.9056 82.3933L18.4324 77.7764L18.6771 76.8001L38.762 81.5391L43.5131 101.573L42.5343 101.817Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9477 91.261H59.7642L37.946 82.4339L28.1992 60.061L37.1304 37.0779L59.9477 27.722L82.969 37.2407L92.1041 60V60.2034L82.5612 82.3525H82.3572L59.9477 91.261ZM38.7413 81.5796L59.9477 90.1627L81.7863 81.5796L91.003 60L82.1941 38.0135L59.9477 28.8203L37.9053 37.8102L29.3003 59.9796L38.7413 81.5796Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.414 83.0441L101.772 77.9594L102.139 77.0238L114.781 82.1085L114.414 83.0441Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49301 36.7553L5.104 37.6953L17.9585 42.9879L18.3475 42.0479L5.49301 36.7553Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7502 18.5085L76.8123 18.1017L82.3178 5.28815L83.2558 5.69493L77.7502 18.5085Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7842 114.692L36.8462 114.325L42.1478 101.308L43.0858 101.675L37.7842 114.692Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.398 36.9644L101.962 42.0417L102.348 42.9829L114.784 37.9055L114.398 36.9644Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1723 76.6051L5.12207 81.904L5.50647 82.8459L18.5567 77.547L18.1723 76.6051Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9954 5.08671L37.053 5.47473L42.3591 18.2965L43.3015 17.9085L37.9954 5.08671Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7605 101.709L76.8203 102.102L82.1193 114.706L83.0595 114.313L77.7605 101.709Z",
    fill: "#81D8D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2191_1100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRound);
export default __webpack_public_path__ + "static/media/Round.7573b0d8b23a21d3e6e0d2de7b82a91a.svg";
export { ForwardRef as ReactComponent };